import { useNavigate } from "react-router-dom";
import Header from "./shared/header";
import Enterprise from "./shared/home/enterprise";
import Footer from "./shared/footer";
import TextHorizontalCarousel from "./shared/texHorizontalCarousel.js";
import DesktopLayout from "./shared/desktop_layout";
import MobileLayout from "./shared/mobile_layout";
import HeroBackground from "./shared/hero_background";
import TextContainer from "./shared/textContainer";
import Process from "./shared/home/process";
import WhatWeDo from "./shared/home/what_we_do";
import HowWeWork from "./shared/home/how_we_work";
import WalkingTheWalk from "./shared/home/walking_the_walk";
import AboutOBZ from "./shared/home/about_obz";
import LetsExplore from "./shared/home/lets_explore";

import { useState, useEffect } from "react";
import PartnerShip from "./shared/home/partnership";

function Home() {
  const navigate = useNavigate();
  const enterpriseData = [
    {
      title: "Assess your readiness",
      img: "images/home/enterprise/enterprise-1.webp",
      img_mob: "images/home/enterprise/enterprise-1-mob.webp",
      buttonText: "Enable Agentic Enterprise",
      redirect: "/",
    },
    {
      title: "Launch early coworkers for high-ROI tasks",
      img: "images/home/enterprise/enterprise-2.webp",
      img_mob: "images/home/enterprise/enterprise-2-mob.webp",
      buttonText: "Enable Agentic Enterprise",
      redirect: "/",
    },
    {
      title: "Build your AI workforce with reusable agent libraries",
      img: "images/home/enterprise/enterprise-3.webp",
      img_mob: "images/home/enterprise/enterprise-3-mob.webp",
      buttonText: "Enable Agentic Enterprise",
      redirect: "/",
    },
    {
      title:
        "Govern securely using AWS AgentCore and your OBZ-powered Command Center",
      img: "images/home/enterprise/enterprise-3.webp",
      img_mob: "images/home/enterprise/enterprise-3-mob.webp",
      buttonText: "Enable Agentic Enterprise",
      redirect: "/",
    },
  ];
  const carouselData1 = [
    {
      img: "/images/home/solution/kuwago.webp",
      img_mob: "/images/home/solution/kuwago_mob.webp",
    },
    {
      img: "/images/home/solution/chattr.webp",
      img_mob: "/images/home/solution/chattr_mob.webp",
    },
    {
      img: "/images/home/solution/hoots.webp",
      img_mob: "/images/home/solution/hoots_mob.webp",
    },
    {
      img: "/images/home/solution/perch.webp",
      img_mob: "/images/home/solution/perch_mob.webp",
    },
    {
      img: "/images/home/solution/pique.webp",
      img_mob: "/images/home/solution/pique_mob.webp",
    },
  ];

  const carouselData2 = [
    {
      img: "/images/home/outcomes/generative-ai.webp",
      img_mob: "/images/home/outcomes/generative-ai-mob.webp",
    },
    {
      img: "/images/home/outcomes/machine-learning.webp",
      img_mob: "/images/home/outcomes/machine-learning-mob.webp",
    },
    {
      img: "/images/home/outcomes/data-platform.webp",
      img_mob: "/images/home/outcomes/data-platform-mob.webp",
    },
    {
      img: "/images/home/outcomes/digital-experience.webp",
      img_mob: "/images/home/outcomes/digital-experience-mob.webp",
    },
  ];

  const [screenSize, setScreenSize] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setScreenSize(window.innerWidth);
    };

    // Add event listener for window resize
    window.addEventListener("resize", handleResize);

    // Remove the event listener when the component unmounts
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const Layout = ({ children, backgroundColor }) => {
    return screenSize <= 768 ? (
      <MobileLayout backgroundColor={backgroundColor}>{children}</MobileLayout>
    ) : (
      <DesktopLayout backgroundColor={backgroundColor}>
        {children}
      </DesktopLayout>
    );
  };

  return (
    <div>
      <HeroBackground backgroundColor="" optional="home">
        <div className="h-full flex flex-col">
          <Header />

          {/* Main Hero Content */}
          <div className="w-[100%] lg:w-[95%] mx-auto flex-1 flex flex-col justify-center px-6 md:px-8 lg:px-12 pt-[80px] md:pt-[100px] lg:pt-[120px] xl:pt-[140px] mt-24">
            {/* Main Heading */}
            <h1 className="text-[36px] sm:text-[44px] md:text-[52px] lg:text-[60px] xl:text-[68px] text-white RoobertMedium tracking-[-0.98px] sm:tracking-[-1.2px] md:tracking-[-1.5px] lg:tracking-[-1.8px] leading-[110%] sm:leading-[105%] md:leading-[100%] max-w-[90%] sm:max-w-[85%] md:max-w-[80%] lg:max-w-[75%] mb-6 md:mb-8">
              The future of work isn't a copilot.
            </h1>

            {/* Subheading */}
            <h2 className="text-[16px] sm:text-[18px] md:text-[20px] lg:text-[22px] xl:text-[24px] leading-[130%] sm:leading-[125%] md:leading-[130%] text-white RoobertMedium max-w-[95%] sm:max-w-[90%] md:max-w-[85%] lg:max-w-[80%] mb-8 md:mb-12 lg:mb-16 opacity-95">
              It's a team of AI coworkers - built for real jobs, with real outcomes. OBZ helps enterprises move beyond tools to design, deploy, and govern AI coworkers at scale.
            </h2>

            {/* Action Buttons Section */}
            <div className="flex flex-col sm:flex-row gap-4 md:gap-6 lg:gap-6 mb-8 md:mb-12 lg:mb-16">
              {/* First Action Group */}
              <div className="flex flex-col justify-between items-start md:h-24">
                <div className="flex items-start justify-start mb-4">
                  <span className="RoobertMedium text-[14px] sm:text-[16px] md:text-[18px] lg:text-[24px] xl:text-[24px] text-white">
                    Built on
                  </span>
                  <img
                    src="images/home/aws_icon.png"
                    className="w-8 h-4 sm:w-10 sm:h-5 md:w-12 md:h-6 lg:w-12 lg:h-6 xl:w-18 xl:h-8 object-contain mt-[7px] lg:mt-[10px] lg:ml-1"
                    alt="AWS"
                  />
                  <span className="RoobertMedium text-[14px] sm:text-[16px] md:text-[18px] lg:text-[24px] xl:text-[24px] text-white">
                    . Powered by your roadmap.
                  </span>
                </div>
                <div className="flex justify-between items-start md:h-24 gap-4">
                  <button
                    className="bg-fluoro-green text-black px-4 py-2.5 md:px-4 md:py-3 lg:px-4 lg:py-2 RoobertSemiBold text-[10px] sm:text-[10px] md:text-[12px] lg:text-[14px] shadow-lg"
                    onClick={() => navigate("/agentic-experience")}
                  >
                    Explore Agentic Enterprise
                  </button>
                  <button
                    className="bg-fluoro-orange text-black px-4 py-2.5 md:px-4 md:py-3 lg:px-4 lg:py-2 RoobertSemiBold text-[10px] sm:text-[10px] md:text-[12px] lg:text-[14px] shadow-lg"
                    onClick={() => navigate("/contact-us")}
                  >
                    Let's Talk
                  </button>
                </div>
              </div>

              {/* Second Action Group */}
            </div>
          </div>
        </div>
      </HeroBackground>

      <Layout>
        <WhatWeDo />
      </Layout>
      <Layout backgroundColor="black">
        <HowWeWork />
      </Layout>
      <Layout>
        <WalkingTheWalk />
      </Layout>
      {/* <Layout backgroundColor="black">
        <Enterprise data={enterpriseData} />
      </Layout> */}
      <Layout>
        <AboutOBZ />
      </Layout>
      <Layout backgroundColor="black">
        <LetsExplore />
      </Layout>
      <Footer />
    </div>
  );
}

export default Home;
